import React from 'react';
import { FaStar, FaStarHalf } from 'react-icons/fa';
// Nova komponenta napravljena po uzoru na "assets\responsive-frontend\js\parts\starRating.jsx" iz razloga što je stil stare komponente nepotrebno pregažen nekoliko puta sa (!important-om).

function StarRating({ rating, maxStars }) {
    const totalStars = maxStars || 5;
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;
    const stars = [];
    for (let i = 0; i < fullStars; i++) {
        stars.push(<FaStar key={`full-${i}`} className="rating-star__icon rating-star__full" />);
    }
    if (hasHalfStar) {
        stars.push(<FaStarHalf key="half" className="rating-star__icon rating-star__half" />);
    }
    const remaining = totalStars - stars.length;
    for (let i = 0; i < remaining; i++) {
        stars.push(<FaStar key={`empty-${i}`} className="rating-star__icon" />);
    }

    return <div className="rating-star-wrap d-flex">{stars}</div>;
}

export default StarRating;
